import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, filter }) =>
    present(
      repository
        .getProjectResourcesListing(project, filter)
        .then(({ projectResources, totalPages }) => ({
          project,
          filter,
          projectResources,
          totalPages,
        }))
        .catch(() => Promise.reject({ project, filter })),
    );
}

export type { Interactor };

export { createInteractor };
